import { LanguageDropdownMenu } from "../../../../LanguageSelect";

export const UpSm = () => {

	return <>	
		<LanguageDropdownMenu />
	</>
}